<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import FundSourceCards from "@/components/widgets/fund-sources-cards.vue";
export default {
    name: "ActualCash",
    props: {
        fundClusters: {
            type: Array,
            required: true
        },
        favorites: {
            type: Array,
            required: true
        },
        loadFC: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LoadingTemplate,
        FundSourceCards
    },
    data() {
        return {
            loading: false,
            tabModel: -1,
            fundSources: [],
            selectedStatus: 'active',
        }
    },
    watch: {
        async tabModel(newVal) {
            if(newVal >= 0){
                this.loading = true;
                if(this.selectedStatus === "active"){
                    await this.getActiveFundSources(this.fundClusters[newVal].id);
                }else{
                    await this.getExpiredFundSources(this.fundClusters[newVal].id);
                }
                this.loading = false;
            }
        },
        fundClusters: {
            immediate: true,
            handler(newVal) {
                if(newVal.length > 0){
                    this.tabModel = 0;
                }
            }
        }
    },
    methods: {
        async getFCStatus(status){
            if(this.tabModel < 0) return;
            this.selectedStatus = status;
            this.loading = true;
            if(status === "active"){
                await this.getActiveFundSources(this.fundClusters[this.tabModel].id);
            }else{
                await this.getExpiredFundSources(this.fundClusters[this.tabModel].id);
            }
            this.loading = false;
        },
        async getActiveFundSources(fundClusterId){
            try{
                const { data: response } = await this.$store.dispatch("fundsource/getActiveFundSource", { fundClusterId: fundClusterId, campusId: this.$store.state.data.selectedCampus.id, cycle: this.$store.state.data.cycle });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                this.fundSources = response;
            }catch(err){
                this.showToast("An error occurred while fetching fund sources.", "error");
            }
        },
        async getExpiredFundSources(fundClusterId){
            try{
                const { data: response } = await this.$store.dispatch("fundsource/getExpiredFundSource", { fundClusterId: fundClusterId, campusId: this.$store.state.data.selectedCampus.id });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                this.fundSources = response;
            }catch(err){
                this.showToast("An error occurred while fetching fund sources.", "error");
            }
        },
        viewTransactions(fundSource){
            this.$emit("view-transactions", fundSource);
        },
    },
}
</script>
<template>
    <div>
        <template v-if="loadFC">
            <div class="my-5 py-5 text-center">
                <LoadingTemplate />
            </div> 
        </template>
        <template v-if="!loadFC && fundClusters.length === 0">
            <div class="text-center my-5 py-5">
                <h5 class="mb-3">No Fund Clusters Available</h5>
                <p class="text-muted mb-0">Please contact the system administrator.</p>
            </div>
        </template>
        <template v-if="!loadFC && fundClusters.length > 0">
            <div class="d-flex">
               <div class="w-300px">
                    <div v-for="(cluster, index) in fundClusters" :key="index" class="cluster-item">
                        <div 
                            class="p-2 border cursor-pointer"
                            :class="{'bg-purple text-white': tabModel === index }"
                            @click="tabModel = index"
                        >
                            <p class="mb-0 font-size-16">
                                <i class="bx bx-circle me-1"></i>{{cluster.cluster}}
                            </p>
                        </div>
                    </div>
               </div>
               <div style="width: calc(100% - 300px);overflow: hidden;" class="ps-3 py-3">
                    <div v-if="loading" class="my-5 py-5 text-center">
                        <LoadingTemplate />
                    </div>
                    <div v-if="!loading && fundSources.length === 0" class="text-center my-5 py-5">
                        <div class="mb-3">
                            <i class="bx bx-info-circle font-size-24 text-muted"></i>
                        </div>
                        <h5 class="text-muted">No Fund Sources Available</h5>
                        <p class="text-muted mb-0">There are no fund sources available for this fund cluster.</p>
                    </div>
                    <div v-if="!loading && fundSources.length">
                        <FundSourceCards 
                            :fundSources="fundSources"
                            @view-transactions="viewTransactions"
                            @view-obligations="$emit('view-obligations', $event)"
                            @view-disbursement="$emit('view-disbursement', $event)"
                            @generate-report="$emit('generate-report', $event)"
                        />
                    </div>
               </div>
            </div>
        </template>
    </div>
</template>